// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatItemPropsContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * FormatItemPropsContainer component
 */
!(function () {

  var FIELD_PROPS_TITLE = 'FORMAT PROPERTIES';
  var observer = require('mobx-react').observer;
  var React = require('react');

  var connect = require('share/enhancers/Izenda.Connect');
  var FormGroup = require('share/components/controls/Izenda.FormGroup');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var PropertiesEditorContainer = require('share/components/controls/Izenda.PropertiesEditorContainer');
  var PropertiesEditorUtils = require('share/utils/Izenda.PropertiesEditorUtils');

  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var DefaultSchema = require('./Izenda.FormatItemPropertiesSchema');

  var EventsUtils = require('EventUtils');
  var classnames = require('classnames');
  var { get } = require('lodash/fp');

  // show title of groups only - item is null
  var UNUSED_PROPS_NULL_CONFIG_FIELD = [
    'fields.generalInfo.fields',
    'fields.itemFormat.fields'
  ];


  var FormatItemPropsContainer = React.createClass({
    propTypes: {
      reportDesignerModel: React.PropTypes.object.isRequired,
      fieldStore: React.PropTypes.object.isRequired
    },

    render: function () {
      var notifyChange = EventsUtils.notifyChange;
      var props = this.props;
      var reportDesignerModel = props.reportDesignerModel || {};
      var reportField = reportDesignerModel.reportFields || {};
      var item = reportField.selectedFormatItem || {};
      var store = props.fieldStore || {};

      return (
        <section className="form-horizontal field-props-container">
          <strong className="title-group">{FIELD_PROPS_TITLE}</strong>

          <FormGroup className="report-parts-ctrl">
            <DropDown blankOption
                      options={CONSTANTS.FORMAT_GROUP}
                      valueField="value"
                      labelField="label"
                      value={reportField.selectedFormatGroup}
                      onChange={this.onChangeFormat} />
            <DropDown blankOption
                      key="reportFields"
                      valueField="id"
                      labelField="name"
                      value={item.id}
                      options={getConfigurableFormatItem()}
                      onChange={setConfigModeToFormatItem.bind(this)} />
          </FormGroup>

          {renderFieldPropertiesEditor()}
        </section>);

      /**
      * Get all format item in format group
      * @return {array} list of format item in format group
      */
      function getConfigurableFormatItem() {
        return reportField.getFormatItems() || [];
      }

      function setConfigModeToFormatItem(value, selectItem) {
        selectItem = selectItem || {};
        reportField.updateFormatItem && reportField.updateFormatItem(selectItem, reportField.selectedFormatGroup);
      }

      /**
      * Render format item config
      * @return {[type]} [description]
      */
      function renderFieldPropertiesEditor() {
        var reportDesignerModel = props.reportDesignerModel;
        var configurationDef = DefaultSchema(reportDesignerModel, item, props.validation);
        var showDefaultProps = ! get('id', item);

        showDefaultProps && removeUsedProps(configurationDef);

        return (
          <fieldset disabled={showDefaultProps}>
          <PropertiesEditorContainer propertyConfig={configurationDef } />
          </fieldset>);

        function removeUsedProps(propConfig) {
          PropertiesEditorUtils.removeProps(propConfig, UNUSED_PROPS_NULL_CONFIG_FIELD);
        }
      }
    },

    onChangeFormat: function (selectedItem) {
      var props = this.props;
      var reportDesignerModel = props.reportDesignerModel || {};
      var reportField = reportDesignerModel.reportFields || {};

      reportField.updateFormatGroup( get('value', selectedItem));

      // move to selected format group
      PropertiesEditorUtils.takeAction('beforeRender', 'formatItemProps');
    }

  });
  module.exports = connect()(FormatItemPropsContainer);
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Formats/Izenda.FormatItemPropsContainer.jsx